module.exports = __webpack_public_path__ + "img/spitter-die-mask-1.f65c96ac.png";